export const getInitials = (...names) => (
  names.reduce((i, n) => (
    i + n?.charAt(0).toUpperCase()
  ), "")
)